import React from 'react';
import { BRAND_LOGO, BRAND_NAME, BRAND_PRODUCT, BRAND_TITLE } from '@/constants/brand';
import { useAuthStyles } from '@/pages/user/authShell';
import { CheckGlyph } from '@/pages/user/authIcons';

/**
 * 品牌标识：带认证角标的图标 + 「Korsmet Auth」（Auth 为蓝色）。
 *
 * 登录、注册、授权三个页面和顶栏都用这一份，改一处四处生效 ——
 * 之前是同样的 JSX 抄了三遍，角标尺寸调一次要改三个文件。
 *
 * inline: 顶栏用。去掉卡片里那条和标题之间的下边距。
 */
export const BrandMark: React.FC<{ inline?: boolean }> = ({ inline = false }) => {
  const { styles } = useAuthStyles();

  return (
    <div className={inline ? styles.markInline : styles.mark}>
      <span className={styles.logoPlate}>
        <img className={styles.logo} src={BRAND_LOGO} alt={BRAND_TITLE} />
        <span className={styles.logoBadge}>
          <CheckGlyph size={7} />
        </span>
      </span>
      <span className={inline ? styles.wordmarkInline : styles.wordmark}>
        {BRAND_NAME} <span className={styles.wordmarkProduct}>{BRAND_PRODUCT}</span>
      </span>
    </div>
  );
};
